import PendingJobs from './styled';

export default PendingJobs;
